import AxiosHelper from '@/helpers/axios.helper';
import DateHelper from '@/helpers/date.helper';
import UrlHelper from '@/helpers/url.helper';
import LangHelper from '@/helpers/language.helper';
import FilesHelper from '@/helpers/files.helper';
import NumericHelper from '@/helpers/numeric.helper';
import ObjectHelper from '@/helpers/object.helper';
import ThreeDHelper from '@/helpers/threeD.helper';
import StringHelper from '@/helpers/string.helper';
import EmailHelper from '@/helpers/email.helper';
import HtmlElementsHelper from '@/helpers/htmlElements.helper';

const helpers = {
  axios: AxiosHelper,
  date: DateHelper,
  url: UrlHelper,
  lang: LangHelper,
  files: FilesHelper,
  numeric: NumericHelper,
  object: ObjectHelper,
  threeD: ThreeDHelper,
  string: StringHelper,
  email: EmailHelper,
  htmlElements: HtmlElementsHelper,
};

export default helpers;
